import { defineDocument } from '../../schema';
export const blogFeedTheFarmMakesAMessOfPushYourLuckDocument = defineDocument({
    id: 'blog:feed-the-farm-makes-a-mess-of-push-your-luck',
    kind: 'blog',
    slug: 'feed-the-farm-makes-a-mess-of-push-your-luck',
    route: '/blog/feed-the-farm-makes-a-mess-of-push-your-luck',
    seo: {
        title: 'Feed The Farm Makes a Mess of Push-Your-Luck',
        description: 'A streamer-friendly farm fiasco with chaos cards, animal avatars, and catastrophic crap-outs',
        imageAsset: 'coverFeedTheFarm',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Feed The Farm Makes a Mess of Push-Your-Luck',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'A streamer-friendly farm fiasco with chaos cards, animal avatars, and catastrophic crap-outs',
            },
        ],
        imageAsset: 'coverFeedTheFarm',
        imageAlt: 'Feed The Farm cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-04-04T00:00:00.000Z'),
        updatedAt: new Date('2026-04-04T00:00:00.000Z'),
        tags: ['games'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'You know the feeling: one more bite sounds like a great idea right up until it very much is not. That universal little lapse in judgment is the entire engine behind ',
                        },
                        {
                            type: 'link',
                            href: '/discover/games/feed-the-farm',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Feed The Farm',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ', our newest game release and one of the filthiest farm experiences on the internet.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__pass-the-pigs-to-the-poop-farm',
                    title: [
                        {
                            type: 'text',
                            text: 'Pass the Pigs to the Poop Farm',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Feed The Farm was inspired by ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'Pass the Pigs',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ', one of our all-time favorite push-your-luck games. Rather than rolling dice, players pick a mystery card each turn and decide whether to try piling more points into their trough or to rest. Sometimes the risk pays off, and sometimes it turns into a regrettable mess.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Maybe we had bacon on the brain, but the eating theme felt like a natural direction for the game. Everybody has experienced the universal feeling they should have stopped two bites ago. From there, the rest of the theme came together quickly: mystery food, bad digestion, and eventually the decision to take crapping out as literally as possible. Are poop jokes silly and childish? Yes, of course. They're also undeniably hilarious.",
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__commit-to-the-bit',
                    title: [
                        {
                            type: 'text',
                            text: 'Commit to the Bit',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Once the theme locked in, there was no point doing it halfway. The avatars became animals. Animals got special sound effects. Crapping out became an extravagant poop animation. The game over scene turned into an over-the-top cascade of poop fireworks across the farm. The game found its look, and we leaned all the way in. It was too funny not to.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__built-for-streamers-and-home-games',
                    title: [
                        {
                            type: 'text',
                            text: 'Built for Streamers and Home Games',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Some games are fun to play. Some games are fun to watch. Feed The Farm is both.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The card reveal is the star: you make your choice, the other two cards flip too, and the whole room reacts to what happened and what could have been. The suspense gets amplified once chaos cards enter the picture. A player can look safe one second and be swapping scores the next.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "You'll quickly see which of your friends are cautious and which take bigger risks than trusting a gas station sushi buffet. Who will bank their points slow-and-steady all the way to victory? Who will go on a feeding frenzy and try to speed run to the finish line?",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Feed The Farm works great with smaller groups (play with as few as two players!) which makes it easy to bring into a casual home game hangout or tight-knit community stream. Risky moments play out every turn and are sure to elicit a reaction from your friends or chat.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__ready-to-pig-out',
                    title: [
                        {
                            type: 'text',
                            text: 'Ready to Pig Out?',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'If your group enjoys risk, suspense, and bathroom humor, then the digestive dysfunction of Feed The Farm might be your kind of mess. Hop, trot, or waddle your way over to the ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'game library',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' to see who knows when to stop eating.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=feed-the-farm-makes-a-mess-of-push-your-luck.js.map